import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DownloadType } from './download-type.model';

@Injectable()
export class DownloadTypeFormService {
  constructor(private fb: FormBuilder) {}

  getForm(downloadType: DownloadType = new DownloadType()): FormGroup {
    return this.fb.group({
      _id: [downloadType._id],
      name: [downloadType.name, Validators.required],
      image: [downloadType.image],
      active: [downloadType.active]
    });   
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/shared/download-type-form.service.ts